module.exports = __webpack_public_path__ + "static/media/dados.6044e6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/recursos/dados.png
// module id = 1127
// module chunks = 0